<div class="selfservice-container">
  @if (isLoading()) {
  <div class="loading-spinner">
    <p>Loading self-service app...</p>
  </div>
  }

  @if (errorMessage()) {
  <div class="error-message">
    <p>{{ errorMessage() }}</p>
  </div>
  }

  <div #mountHost class="selfservice-mount-host" [class.selfservice-mount-host--hidden]="errorMessage()"></div>
</div>
